export const EventType = {
  Canvass: 'CANVASS',
  PhoneBank: 'PHONE_BANK',
  TextBank: 'TEXT_BANK',
  Meeting: 'MEETING',
  Community: 'COMMUNITY',
  Fundraiser: 'FUNDRAISER',
  MeetGreet: 'MEET_GREET',
  HouseParty: 'HOUSE_PARTY',
  VoterReg: 'VOTER_REG',
  Training: 'TRAINING',
  FriendToFriendOutreach: 'FRIEND_TO_FRIEND_OUTREACH',
  DebateWatch_Party: 'DEBATE_WATCH_PARTY',
  Rally: 'RALLY',
  TownHall: 'TOWN_HALL',
  OfficeOpening: 'OFFICE_OPENING',
  Barnstorm: 'BARNSTORM',
  SolidarityEvent: 'SOLIDARITY_EVENT',
  CommunityCanvass: 'COMMUNITY_CANVASS',
  SignatureGathering: 'SIGNATURE_GATHERING',
  Carpool: 'CARPOOL',
  Workshop: 'WORKSHOP',
  Petition: 'PETITION',
  AutomatedPhoneBank: 'AUTOMATED_PHONE_BANK',
  LetterWriting: 'LETTER_WRITING',
  LiteratureDropOff: 'LITERATURE_DROP_OFF',
  VisibilityEvent: 'VISIBILITY_EVENT',
  AdvocacyCall: 'ADVOCACY_CALL',
  Other: 'OTHER'
}

export const eventTypeDisplayNames = {
  [EventType.Canvass]: 'Canvass',
  [EventType.PhoneBank]: 'Phone bank',
  [EventType.TextBank]: 'Text bank',
  [EventType.Meeting]: 'Meeting',
  [EventType.Community]: 'Community event',
  [EventType.Fundraiser]: 'Fundraiser',
  [EventType.MeetGreet]: 'Meet-and-greet',
  [EventType.HouseParty]: 'House party',
  [EventType.VoterReg]: 'Voter registration',
  [EventType.Training]: 'Training',
  [EventType.FriendToFriendOutreach]: 'Friend-to-friend outreach',
  [EventType.DebateWatch_Party]: 'Watch party',
  [EventType.Rally]: 'Rally',
  [EventType.TownHall]: 'Town hall',
  [EventType.OfficeOpening]: 'Office opening',
  [EventType.Barnstorm]: 'Barnstorm',
  [EventType.SolidarityEvent]: 'Solidarity event',
  [EventType.CommunityCanvass]: 'Community canvass',
  [EventType.SignatureGathering]: 'Signature gathering',
  [EventType.Carpool]: 'Carpool',
  [EventType.Workshop]: 'Workshop',
  [EventType.Petition]: 'Petition',
  [EventType.AutomatedPhoneBank]: 'Phone bank - automated',
  [EventType.LetterWriting]: 'Letter writing event',
  [EventType.LiteratureDropOff]: 'Literature drop-off',
  [EventType.VisibilityEvent]: 'Visibility event',
  [EventType.AdvocacyCall]: 'Call your representative',
  [EventType.Other]: 'Other events'
}
